import React from 'react'

const AgencyHost = () => {
  return (
    <div>AgencyHost</div>
  )
}

export default AgencyHost